import React, { useState, useContext } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getMemberById, getRegions, amendMemberRegion } from "../../../api/apiServices";
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'
import Loader from '../../Common/Spinner/Loader';


const AmendRegion = () => {
    let [isLoading, setIsLoading] = useState(true);
    const params = useParams();
    const id = parseInt(params.id)

    const [member, setMember] = useState({});
    const [new_region, setNewRegion] = useState("");
    const [old_pf_number, setOldPfNumber] = useState("");
    const queryClient = useQueryClient();

    const {
        data: memberInfo,
    } = useQuery(['memberInfo', id], () => getMemberById(id), {
        onSuccess: async (res) => {
            setMember(res)
            setIsLoading(false)
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message"
            })
        }
    });

    const {
        data: regions,
    } = useQuery('regions', () => getRegions());

        const fullname = member?.title + " " + member?.first_name + " " + member?.middle_name + " " + member?.last_name
        const pf_number = member?.pf_number
        const current_region = member?.region
   
   
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/change_region";


    const amendRegionMutation = useMutation(amendMemberRegion, {
        onSuccess: async (res) => {
            if (res.status === false) {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message"
                })
            } else {
                setOldPfNumber(res.old_pf_number)
                setIsLoading(false)
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message"
                })
                // Invalidate cached data
                queryClient.invalidateQueries("memberInfo")
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message"
            })
        }
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true)
        const amendData = {
            id: id,
            region_code: new_region
        }
        amendRegionMutation.mutate(amendData)
    }


    const handleCancel = (e) => {
        e.preventDefault();
        navigate(from, { replace: true });
    }

    let approvalForm
    if (!old_pf_number) {
        approvalForm = (
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-9">
                            <h4 className="panel-title">
                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                <span> Amend Region</span>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group row">
                            <label htmlFor="current_region" className="col-sm-2">Current Region</label>
                            <div className="col-sm-4">
                                <input
                                    type="text"
                                    id="current_region"
                                    autoComplete="off"
                                    disabled
                                    value={current_region}
                                    name="current_region"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="new_region" className="col-sm-2">New Region</label>
                            <div className="col-sm-4">
                                <select
                                    type="text"
                                    id="new_region"
                                    autoComplete="off"
                                    value={new_region}
                                    name="new_region"
                                    onChange={(e) => setNewRegion(e.target.value)}
                                    className="form-control"
                                >
                                    <option value="">Select Region</option>
                                    {regions?.map((reg, index) =>
                                        <option value={reg.region_code} key={index}>
                                            {reg.region} - {reg.region_code}
                                        </option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* <div className="form-group row"> */}
                        <label className="col-sm-2"></label>
                        <button type="submit" className="btn btn-success">
                            Amend Region
                        </button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button" className="btn btn-warning" onClick={handleCancel}>
                            Cancel
                        </button>
                        {/* </div> */}
                    </form>
                </div>
            </div>
        )
    } else {
        approvalForm = (
            <>
                <div className="panel-footer">
                    <button type="button" className="btn btn-danger" onClick={handleCancel}>
                        Cancel
                    </button>
                </div>
            </>
        )
    }
    let content
    if (isLoading) {
        content = <div className="loader">
            <p>Loading Region amendment...</p>
            <Loader />
        </div>;
    } else {
        content = (
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-5">
                            <h4 className="panel-title">
                                <i className="fa fa-file-text" aria-hidden="true"></i>
                                <span> Member Information</span>
                            </h4>
                            <br />
                            <div className="table-responsive lg">
                                <table className="table table-borderless">
                                    <tbody>
                                        <>
                                            <tr>
                                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#fff", align: "left" }}>Full Name</td>
                                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{fullname}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#fff", align: "left" }}>PF Number</td>
                                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> : {pf_number}</td>
                                            </tr>
                                            {old_pf_number ?
                                                <tr>
                                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#fff", align: "left" }}>Old PF Number</td>
                                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{old_pf_number}</td>
                                                </tr>
                                                : null}
                                        </>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    {approvalForm}
                </div>
            </div>
        )
    }


    return (
        <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>Region Amendment</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Amend Member Region</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </section></>
    );
}

export default AmendRegion;